<div class="user-view">
    <ng-container [dynamic]="view()"></ng-container>
</div>
